import { Rad } from '../../lib/types/models/rad/rad'
import { RadInput } from '../../lib/types/models/rad/rad-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createRad(data: RadInput) {
  return restApiClient.url(constructApiUrl(API.rads.create.url, null)).post<Rad, RadInput>(data)
}
